module.exports = __webpack_public_path__ + "media/images/file-icons/64/001-interface-1-59ca556b68f252234f5b98d863e7e159.png";